import React, { useRef } from 'react';
import styles from './PhotoUpload.module.css';

// Props (single mode):  photo (File|null), onChange(File|null)
// Props (multiple mode): photos (File[]),   onChange(File[]),  multiple=true
export default function PhotoUpload({ photo, photos, multiple = false, onChange }) {
    const inputRef = useRef(null);

    const handleFiles = (fileList) => {
        const images = Array.from(fileList).filter((f) => f.type.startsWith('image/'));
        if (!images.length) return;
        if (multiple) {
            onChange([...(photos || []), ...images]);
        } else {
            onChange(images[0]);
        }
    };

    const removePhoto = (index) => {
        if (multiple) {
            onChange((photos || []).filter((_, i) => i !== index));
        } else {
            onChange(null);
            if (inputRef.current) inputRef.current.value = '';
        }
    };

    const DropZone = () => (
        <div
            className={styles.dropZone}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => { e.preventDefault(); handleFiles(e.dataTransfer.files); }}
            onClick={() => inputRef.current?.click()}
        >
            <input
                ref={inputRef}
                type="file"
                accept="image/*"
                multiple={multiple}
                onChange={(e) => handleFiles(e.target.files)}
                className={styles.hiddenInput}
            />
            <div className={styles.uploadIcon}>📸</div>
            <p className={styles.uploadTitle}>{multiple ? 'اسحب الصور هنا' : 'اسحب الصورة هنا'}</p>
            <p className={styles.uploadSub}>
                {multiple
                    ? 'أو اضغط للبحث — JPG, PNG, WEBP (max 5MB لكل صورة)'
                    : 'أو اضغط للبحث — JPG, PNG, WEBP (max 5MB)'}
            </p>
        </div>
    );

    if (multiple) {
        return (
            <div className={styles.container}>
                {photos?.length > 0 && (
                    <div className={styles.photoGrid}>
                        {photos.map((file, i) => (
                            <div key={i} className={styles.thumb}>
                                <img src={URL.createObjectURL(file)} alt="" className={styles.thumbImg} />
                                <button type="button" className={styles.thumbRemove} onClick={() => removePhoto(i)}>✕</button>
                            </div>
                        ))}
                    </div>
                )}
                <DropZone />
            </div>
        );
    }

    return (
        <div className={styles.container}>
            {photo ? (
                <div className={styles.preview}>
                    <img src={URL.createObjectURL(photo)} alt="preview" className={styles.previewImg} />
                    <button type="button" className={styles.removeBtn} onClick={() => removePhoto(0)}>✕</button>
                    <span className={styles.fileName}>{photo.name}</span>
                </div>
            ) : (
                <DropZone />
            )}
        </div>
    );
}
